import { AfterViewInit } from '@angular/core';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NouisliderComponent } from 'ng2-nouislider';

@Component({
  selector: 'input-slider-nolinear',
  templateUrl: './input-slider-nolinear.component.html',
  styleUrls: ['./input-slider-nolinear.component.css']
})
export class InputSliderNolinearComponent implements AfterViewInit {

  @Input() id: string = '';
  @Input() title: string = '';
  @Input() control: UntypedFormControl;
  @Input() titleValues: string = '';
  @Input() range: any = { min: 0, max: 100 };
  @Input() margin: Array<{ value: number, margin: number }> = [];
  @Input() format: string = '';
  @Input() secondaryMaxText: string = '';

  @Output() changeValuesEvent = new EventEmitter<undefined>();

  @ViewChild('nouislidernolinear') inputSlider: NouisliderComponent;

  public rangeConfig: any = {
    behaviour: 'drag',
    connect: true,
    snap: true,
    range: this.range
  };

  constructor() { }

  ngAfterViewInit(): void {
    this.inputSlider.slider.updateOptions({ range: this.range })
  }


  onChangeValuesSlider(): void {
    this.changeValuesEvent.next(undefined);
  }

  eventUpdate(e: any) {

    const min = e[0];
    const max = e[1];


    if (max === this.range.max) {
      this.inputSlider.slider.updateOptions({ margin: 1 })
      return;

    }

    const ix: number = this.margin.findIndex(x => x.value === min);

    if (ix === -1)
      return;

    const newMargin: number = this.margin[ix].margin;

    this.inputSlider.slider.updateOptions({ margin: newMargin })

  }

}